/**
 * Heap tracking utility functions for ECS survey events
 */

/**
 * Track ECS survey completion with optional share link attribution
 */
export function trackEcsSurveyCompletion(properties?: {
  shareLinkId?: string | null;
  companyId?: number;
  userId?: string;
  [key: string]: any;
}) {
  if (!window.heap) return;

  // Check if we need to get share link ID from sessionStorage
  const shareLinkIdFromSession = !properties?.shareLinkId ? getEcsShareLinkId() : null;
  const shareLinkId = properties?.shareLinkId || shareLinkIdFromSession;

  window.heap.track("ECS Survey Completed", {
    ...properties,
    shareLinkId: shareLinkId || "direct",
    timestamp: new Date().toISOString(),
  });

  // Only clear the share link ID if we retrieved it from sessionStorage
  if (shareLinkIdFromSession) {
    clearEcsShareLinkId();
  }
}

/**
 * Track when user visits ECS from a share link
 */
export function trackEcsShareLinkVisit(shareLinkId: string) {
  if (!window.heap) return;

  window.heap.track("ECS Share Link Visited", {
    shareLinkId,
    timestamp: new Date().toISOString(),
  });
}

/**
 * Track ECS survey step progression
 */
export function trackEcsSurveyStep(step: string, properties?: Record<string, any>) {
  if (!window.heap) return;

  const shareLinkId = getEcsShareLinkId();

  window.heap.track("ECS Survey Step", {
    step,
    shareLinkId: shareLinkId || "direct",
    ...properties,
    timestamp: new Date().toISOString(),
  });
}

// SessionStorage key for ECS share link tracking
const ECS_SHARE_LINK_KEY = "ecs_share_link_id";

/**
 * Store share link ID in sessionStorage
 */
export function setEcsShareLinkId(shareLinkId: string) {
  if (typeof window !== "undefined" && window.sessionStorage) {
    window.sessionStorage.setItem(ECS_SHARE_LINK_KEY, shareLinkId);
  }
}

/**
 * Get share link ID from sessionStorage
 */
export function getEcsShareLinkId(): string | null {
  if (typeof window !== "undefined" && window.sessionStorage) {
    return window.sessionStorage.getItem(ECS_SHARE_LINK_KEY);
  }
  return null;
}

/**
 * Clear share link ID from sessionStorage
 */
export function clearEcsShareLinkId() {
  if (typeof window !== "undefined" && window.sessionStorage) {
    window.sessionStorage.removeItem(ECS_SHARE_LINK_KEY);
  }
}
